export const VIEW_MORE_STYLE = {
  LINK: 'LINK',
  BUTTON: 'BUTTON',
  EXPANDABLE: 'EXPANDABLE'
}

export const VIEW_MORE_TEXT = {
  DEFAULT: 'View more',
  EXPANDED: 'View less'
}

export const CLASS_BY_VIEW_MORE_STYLE = {
  [VIEW_MORE_STYLE.LINK]: 'a-view-more__link',
  [VIEW_MORE_STYLE.BUTTON]: 'a-view-more__button',
  [VIEW_MORE_STYLE.EXPANDABLE]: 'a-view-more__expandable'
}
